module.exports = __webpack_public_path__ + "static/media/details__out.ebdc7d6e.svg";